export type ImagePresetFormat = "JPEG" | "PNG" | "WEBP";

export type ImagePreset = {
  id: string;
  label: string;
  description: string;
  width: number;
  height?: number;
  quality: number;
  format: ImagePresetFormat;
};

export const IMAGE_PRESETS: readonly ImagePreset[] = [
  {
    id: "product-hero",
    label: "Hero",
    description: "1600px wide product hero",
    width: 1600,
    quality: 60,
    format: "WEBP",
  },
  {
    id: "product-highlight",
    label: "Highlight",
    description: "1600px wide product highlight",
    width: 1600,
    quality: 80,
    format: "WEBP",
  },
  {
    id: "category-image",
    label: "Category",
    description:
      "Optimized WebP category image, up to 400px wide",
    width: 400,
    quality: 55,
    format: "WEBP",
  },
];

export function getImagePreset(id: string) {
  return IMAGE_PRESETS.find((preset) => preset.id === id) ?? null;
}

export function imagePresetExtension(format: ImagePresetFormat) {
  if (format === "PNG") return "png";
  if (format === "WEBP") return "webp";
  return "jpg";
}

export function imagePresetMimeType(format: ImagePresetFormat) {
  if (format === "PNG") return "image/png";
  if (format === "WEBP") return "image/webp";
  return "image/jpeg";
}

export function filenameWithoutExtension(filename: string) {
  const lastDot = filename.lastIndexOf(".");
  return lastDot > 0 ? filename.slice(0, lastDot) : filename;
}

export function buildPresetFilename(filename: string, preset: ImagePreset) {
  return `${filenameWithoutExtension(filename)}-${preset.id}.${imagePresetExtension(preset.format)}`;
}
